import { LocaleEnum, type Locale } from "@repo/i18n";
import { useTranslation } from "react-i18next";

/** The active catalog language (`cs` for a `cs-CZ` browser), re-rendering on change. */
export const useLocale = (): Locale => {
  const { i18n } = useTranslation();
  return (i18n.resolvedLanguage ?? LocaleEnum.EN) as Locale;
};
